'use strict';

import _ from 'underscore';
import cookies from 'js-cookie';

const idCookiesMap = {
  Business_Category__c: '_sk_vertical',
  Business_Category_Type__c: '_sk_businessType',
  Years_in_Business__c: '_sk_yearsInBusiness',
  Has_POS_System_Currently__c: '_sk_currentPOS',
  Timeline_for_POS__c: '_sk_timeline',
  Number_of_Locations__c: '_sk_locations',
  Number_of_Registers__c: '_sk_registers',
  eCommerce__c: '_sk_ecommerce',
  Average_Monthly_Sales__c: '_sk_sales',
};

const mktoStepsAutofill = function(form, steps, fieldsets) {
  const formInputVal = {};
  const skipSteps = [];
  let incrementStep = false;
  let pauseSkip = false;
  let currentStep = 1;
  const reference = this;

  _.every(fieldsets, (fieldsetElem, index) => {
    const fieldsetInputs = fieldsetElem.querySelectorAll('input, select');

    _.every(fieldsetInputs, (inputElem) => {
      const inputId = inputElem.id;
      const cookieVal = cookies.get(idCookiesMap[inputId]);

      if (idCookiesMap[inputId] !== undefined && cookieVal) {
        var formId = form.getId();
        if (formId !== 2342) {
          incrementStep = true;
        }

        formInputVal[inputId] = cookieVal;
      } else {
        incrementStep = false;
      }

      if (inputId === reference.$root.marketoCurrentStepId) {
        pauseSkip = true;
      }

      return incrementStep;
    });

    if (incrementStep && !pauseSkip) {
      skipSteps.push(currentStep);
    }

    form.vals(formInputVal);

    pauseSkip = false;
    currentStep++;
    return true;
  });

  return skipSteps;
};

export default mktoStepsAutofill;
